import _ from 'lodash'
import uuidv1 from 'uuid/v1'
import {
  readAsArrayBuffer
} from 'promise-file-reader'
import fileType from 'file-type'
import {
  ANT_UPLOAD_STATUS
} from '../constants/globalTypes'

export const getIsFileUploading = file => {
  // 判斷以上傳完成狀態為 status 時有時候是 percent 100% 有時候是只有 url
  // 所以 uploading 這些都沒有才代表還在上傳中
  return (
    (file.status === ANT_UPLOAD_STATUS.UPLOADING) &&
    (file.percent !== 100) &&
    !('url' in file)
  )
}

export const getIsAnyFileUploading = (fileList) => {
  return _.some(fileList, getIsFileUploading)
}
export const getIsAllFileUploaded = (fileList) => !getIsAnyFileUploading(fileList)
export const getIsEmptyFileList = (fileList) => _.isEmpty(fileList)
export const filterFileListByError = (fileList) => _.filter(fileList, f => f.status !== ANT_UPLOAD_STATUS.ERROR)
export const getHasAnyErrorFile = (fileList) => _.some(fileList, file => file.status === ANT_UPLOAD_STATUS.ERROR)

export const getMimetype = async (file) => {
  try {
    const fileBuffer = await readAsArrayBuffer(file)
    // passing the second argument to allow jest mocking this function
    // NOTE: file-type doesn't transpile es5 from v4, so we had to lock v3.9.0
    const mimeType = fileType(new Uint8Array(fileBuffer), file)
    return mimeType
  } catch (e) {
    console.log('getMimetype', e)
    const result = {
      ext: '',
      mime: ''
    }
    return result
  }
}

export const getImageDimension = (file) => {
  return new Promise((resolve, reject) => {
    const img = new window.Image()
    img.src = window.URL.createObjectURL(file)
    img.onload = () => {
      resolve({
        preview: img.src,
        width: Math.max(img.naturalWidth, img.clientWidth),
        height: Math.max(img.naturalHeight, img.clientHeight)
      })
    }
    img.onerror = (e) => {
      reject(e)
    }
  })
}

export const ORIENTATION_TYPE = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait'
}

export const getVideoDimension = (file) => {
  return new Promise((resolve, reject) => {
    try {
      const video = window.document.createElement('video')
      video.preload = 'metadata'
      video.src = window.URL.createObjectURL(file)
      // Load video in Safari / IE11
      video.muted = true
      video.crossOrigin = 'Anonymous'
      video.playsInline = true
      video.onloadeddata = () => {
        const { videoWidth, videoHeight } = video
        // orientation rule refs to https://medium.com/@subsign/vertical-vs-horizontal-video-2ed0a76a02ce
        resolve({
          orientation: videoWidth >= videoHeight ? ORIENTATION_TYPE.LANDSCAPE : ORIENTATION_TYPE.PORTRAIT,
          width: videoWidth,
          height: videoHeight
        })
      }
      video.onerror = (e) => {
        reject(e)
      }
      video.play()
    } catch (e) {
      console.log('getVideoDimension error', e)
      reject(e)
    }
  })
}

export const setUidAndMimeType = fileList => {
  return Promise.all(_.map(fileList, async file => {
    try {
      !file.uid && _.merge(file, {
        uid: uuidv1()
      })
      const mimetype = await getMimetype(file)
      return _.merge(file, {
        mimetype
      })
    } catch (e) {
      console.log('setUidAndMimeType erorr', e)
      throw e
    }
  }))
}

export const setDimension = fileList => {
  return Promise.all(_.map(fileList, async file => {
    try {
      const mime = _.get(file, 'mimetype.mime')
      if (/^image\/*/.test(mime)) {
        const dimension = await getImageDimension(file)
        return _.merge(file, {
          dimension
        })
      } else if (/^video\/*/.test(mime)) {
        const dimension = await getVideoDimension(file)
        return _.merge(file, {
          dimension
        })
      }
    } catch (e) {
      console.log('setDimension erorr', e)
      throw e
    }
  }))
}

export const verifyFileMimeType = (file, acceptTypeRegexp) => {
  if (!acceptTypeRegexp) {
    throw new Error('requires acceptTypeRegexp to verify')
  }
  const mime = _.get(file, 'mimetype.mime')
  const type = file.type || ''
  return acceptTypeRegexp.test(mime) || acceptTypeRegexp.test(type)
}

export const verifyMismatchedFileMimeType = (file) => {
  const mime = _.get(file, 'mimetype.mime')
  if (mime && file.type !== mime) {
    return '檔名與檔案內容不符，請確認格式後再重新上傳'
  }
  return false
}

export const mergeFilesByUid = (thisFiles, nextFiles) => {
  const files = Array.isArray(nextFiles) ? nextFiles : [nextFiles]
  const unionFiles = _.map(_.merge(
    _.mapKeys(thisFiles, k => k.uid),
    _.mapKeys(files, k => k.uid)
  ))
  return unionFiles
}
